export interface CsvRowError {
	field: string;
	message: string;
	row: number;
}

export const transformErrors = (errors: readonly CsvRowError[]): string[] =>
	errors.map((error) => `Row ${error.row}: ${error.field} - ${error.message}`);

/**
 * Case-insensitive name normalization used by CSV imports to look up existing
 * records (customers, terms, price groups) by name without being tripped up by
 * casing or surrounding whitespace.
 */
const normalizeImportName = (name: string): string => name.trim().toLowerCase();

export const collapseWhitespace = (value: string): string => value.replace(/\s+/g, " ").trim();

export const normalizeMatchKey = (value: string): string => collapseWhitespace(value).toLowerCase();

export const normalizeLocationKey = (value: string): string =>
	value
		.split(">")
		.map((segment) => normalizeMatchKey(segment))
		.filter((segment) => segment !== "")
		.join(" > ");

export const normalizeCategoryCode = (code: string): string => code.trim();

export const isNonNegativeNumber = (value: string): boolean => {
	const parsed = Number(value.trim());
	return Number.isFinite(parsed) && parsed >= 0;
};

export const csvRowNumberFromIndex = (index: number): number => index + 2;

export const csvIndexFromRowNumber = (rowNumber: number): number => rowNumber - 2;

export default normalizeImportName;
